module.exports = __webpack_public_path__ + "img/bg2.9014d4c6.png";